export const CREATEEDITRECEIPT_GETALLSITEITEMS_LOADING =
  'CREATEEDITRECEIPT_GETALLSITEITEMS_LOADING';
export const CREATEEDITRECEIPT_GETALLSITEITEMS_SUCCESS =
  'CREATEEDITRECEIPT_GETALLSITEITEMS_SUCCESS';
export const CREATEEDITRECEIPT_GETALLSITEITEMS_ERROR =
  'CREATEEDITRECEIPT_GETALLSITEITEMS_ERROR';

export const CREATEEDITRECEIPT_POSTSAVERECEIPT_LOADING =
  'CREATEEDITRECEIPT_POSTSAVERECEIPT_LOADING';
export const CREATEEDITRECEIPT_POSTSAVERECEIPT_SUCCESS =
  'CREATEEDITRECEIPT_POSTSAVERECEIPT_SUCCESS';
export const CREATEEDITRECEIPT_POSTSAVERECEIPT_ERROR =
  'CREATEEDITRECEIPT_POSTSAVERECEIPT_ERROR';

export const CREATEEDITRECEIPT_GETRECEIPTDETAILS_LOADING =
  'CREATEEDITRECEIPT_GETRECEIPTDETAILS_LOADING';
export const CREATEEDITRECEIPT_GETRECEIPTDETAILS_SUCCESS =
  'CREATEEDITRECEIPT_GETRECEIPTDETAILS_SUCCESS';
export const CREATEEDITRECEIPT_GETRECEIPTDETAILS_ERROR =
  'CREATEEDITRECEIPT_GETRECEIPTDETAILS_ERROR';

export const CREATEEDITRECEIPT_CLEARALL = 'CREATEEDITRECEIPT_CLEARALL';



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/state/createEditReceipt/types.js